export interface Camera {
  camera_id: string;
  location: string;
  lat: string;
  lon: string;
  iframeUrl?: string;
  iframeWidth?: number;
  iframeHeight?: number;
}

export const cameras: Camera[] = [
  {
    "camera_id": "2",
    "location": "Grant & Vallejo St.",
    "lat": "37.79940592",
    "lon": "-122.4072996",
    "iframeUrl": "https://g1.ipcamlive.com/player/player.php?alias=683bda39c526e",
    "iframeWidth": 800,
    "iframeHeight": 600
  },
  {
    "camera_id": "3",
    "location": "Grant & Vallejo St.",
    "lat": "37.79940592",
    "lon": "-122.4072996",
    "iframeUrl": "https://g1.ipcamlive.com/player/player.php?alias=683bda39c526e",
    "iframeWidth": 800,
    "iframeHeight": 600
  },
  {
    "camera_id": "21",
    "location": "Howard & 8th",
    "lat": "37.77672386368274",
    "lon": "-122.41117032030563"
  },
  {
    "camera_id": "20",
    "location": "Howard & 8th",
    "lat": "37.77672386368274",
    "lon": "-122.41117032030563"
  },
  {
    "camera_id": "5",
    "location": "Grant & Columbus",
    "lat": "37.798408872312216",
    "lon": "-122.40722459968052"
  },
  {
    "camera_id": "1",
    "location": "Broadway & Kearny",
    "lat": "37.797779711558391",
    "lon": "-122.4055936"
  },
  {
    "camera_id": "9",
    "location": "Grant & Green St.",
    "lat": "37.799957262628475",
    "lon": "-122.40742215399251"
  },
  {
    "camera_id": "6",
    "location": "Columbus & Vallejo",
    "lat": "37.798453909686458",
    "lon": "-122.40734999295022"
  },
  {
    "camera_id": "13",
    "location": "Miley and Baker St",
    "lat": "37.797293265138215",
    "lon": "-122.4455799633692"
  },
  {
    "camera_id": "4",
    "location": "Columbus & Broadway",
    "lat": "37.797755363514213",
    "lon": "-122.40670371140298"
  },
  {
    "camera_id": "7",
    "location": "Columbus & Broadway",
    "lat": "37.797436535574874",
    "lon": "-122.40588051819242"
  },
  {
    "camera_id": "11",
    "location": "Jasper Pl & Green St.",
    "lat": "37.799673038395447",
    "lon": "-122.408167977311"
  },
  {
    "camera_id": "10",
    "location": "Jasper Pl & Green St.",
    "lat": "37.799687295760748",
    "lon": "-122.40786687341574"
  },
  {
    "camera_id": "15",
    "location": "Third St and Townsend",
    "lat": "37.779030822193945",
    "lon": "-122.3927249159742",
    "iframeUrl": "https://g1.ipcamlive.com/player/player.php?alias=68408c288eb1f",
    "iframeWidth": 800,
    "iframeHeight": 600
  },
  {
    "camera_id": "17",
    "location": "Townsend and Third St",
    "lat": "37.779030822193945",
    "lon": "-122.3927249159742",
    "iframeUrl": "https://g1.ipcamlive.com/player/player.php?alias=68408c288eb1f",
    "iframeWidth": 800,
    "iframeHeight": 600
  },
  {
    "camera_id": "16",
    "location": "Townsend and Third St",
    "lat": "37.779030822193945",
    "lon": "-122.3927249159742",
    "iframeUrl": "https://g1.ipcamlive.com/player/player.php?alias=68408c288eb1f",
    "iframeWidth": 800,
    "iframeHeight": 600
  },
  {
    "camera_id": "19",
    "location": "Baker and Greenwich St",
    "lat": "37.797764251953808",
    "lon": "-122.44596503708556"
  },
  {
    "camera_id": "18",
    "location": "Baker and Greenwich St",
    "lat": "37.797764251953808",
    "lon": "-122.44596503708556"
  },
  {
    "camera_id": "14",
    "location": "Baker and Greenwich St",
    "lat": "37.797558482791018",
    "lon": "-122.44576124452443"
  },
  {
    "camera_id": "8",
    "location": "Columbus & Vallejo St.",
    "lat": "37.798933919150436",
    "lon": "-122.4080468186648"
  },
  {
    "camera_id": "12",
    "location": "Broadway & Montgomery St.",
    "lat": "37.798248967951068",
    "lon": "-122.4042725941748"
  },
  {
    "camera_id": "29",
    "location": "Union and Stockton",
    "lat": "37.80074162",
    "lon": "-122.4092186"
  },
  {
    "camera_id": "27",
    "location": "Union and Stockton",
    "lat": "37.80074162",
    "lon": "-122.4092186"
  },
  {
    "camera_id": "28",
    "location": "Union and Stockton",
    "lat": "37.80074162",
    "lon": "-122.4092186"
  },
  {
    "camera_id": "30",
    "location": "Union and Stockton",
    "lat": "37.80074162",
    "lon": "-122.4092186"
  },
  {
    "camera_id": "36",
    "location": "20th and Valencia",
    "lat": "37.75843214",
    "lon": "-122.4219923"
  },
  {
    "camera_id": "35",
    "location": "Valencia and 20th",
    "lat": "37.75843214",
    "lon": "-122.4219923"
  },
  {
    "camera_id": "34",
    "location": "Valencia and 20th",
    "lat": "37.75843214",
    "lon": "-122.4219923"
  },
  {
    "camera_id": "33",
    "location": "S Park St",
    "lat": "37.78161474",
    "lon": "-122.3942873"
  },
  {
    "camera_id": "32",
    "location": "S Park St",
    "lat": "37.78161474",
    "lon": "-122.3942873",
    "iframeUrl": "https://g1.ipcamlive.com/player/player.php?alias=kleinerperkins",
    "iframeWidth": 800,
    "iframeHeight": 451
  },
  {
    "camera_id": "31",
    "location": "S Park St",
    "lat": "37.78161474",
    "lon": "-122.3942873"
  },
  {
    "camera_id": "25",
    "location": "Columbus and Lombard",
    "lat": "37.80310864",
    "lon": "-122.414125"
  },
  {
    "camera_id": "24",
    "location": "Columbus and Lombard",
    "lat": "37.80310864",
    "lon": "-122.414125"
  },
  {
    "camera_id": "26",
    "location": "Lombard and Columbus",
    "lat": "37.80310864",
    "lon": "-122.414125"
  },
  {
    "camera_id": "40",
    "location": "Folsom and 8th",
    "lat": "37.77564313",
    "lon": "-122.4092154"
  },
  {
    "camera_id": "41",
    "location": "Folsom and 8th",
    "lat": "37.77564313",
    "lon": "-122.4092154",
    "iframeUrl": "https://g1.ipcamlive.com/player/player.php?alias=6844be2a33614",
    "iframeWidth": 800,
    "iframeHeight": 451
  },
  {
    "camera_id": "22",
    "location": "Columbus and Mason",
    "lat": "37.80157365",
    "lon": "-122.4127537"
  },
  {
    "camera_id": "23",
    "location": "Columbus and Greenwich",
    "lat": "37.80157365",
    "lon": "-122.4127537"
  },
  {
    "camera_id": "38",
    "location": "Gough and Oak",
    "lat": "37.7746422",
    "lon": "-122.4224746",
    "iframeUrl": "https://g1.ipcamlive.com/player/player.php?alias=6769bac543ef3",
    "iframeWidth": 800,
    "iframeHeight": 451
  },
  {
    "camera_id": "37",
    "location": "Gough and Oak",
    "lat": "37.7746422",
    "lon": "-122.4224746",
    "iframeUrl": "https://g1.ipcamlive.com/player/player.php?alias=6769bac543ef3",
    "iframeWidth": 800,
    "iframeHeight": 451
  },
  {
    "camera_id": "39",
    "location": "Oak and Gough",
    "lat": "37.7746422",
    "lon": "-122.4224746",
    "iframeUrl": "https://g1.ipcamlive.com/player/player.php?alias=6769bac543ef3",
    "iframeWidth": 800,
    "iframeHeight": 451
  },
  {
    "camera_id": "42",
    "location": "Polk and Sacramento",
    "lat": "37.79196121913595",
    "lon": "-122.42088434124945"
  },
  {
    "camera_id": "43",
    "location": "Polk and Sacramento",
    "lat": "37.79178218705454",
    "lon": "-122.42084520243912"
  }
  ,
  {
    "camera_id": "44",
    "location": "Castro and Market",
    "lat": "37.76181515663832",
    "lon": "-122.43518056075168"
  },
  {
    "camera_id": "45",
    "location": "Castro and 17th",
    "lat": "37.76245725984413",
    "lon": "-122.43499394948881"
  },
  {
    "camera_id": "46",
    "location": "Castro and 17th",
    "lat": "37.760983003532566",
    "lon": "-122.43511034949147"
  },
  {
    "camera_id": "47",
    "location": "Castro and 18th",
    "lat": "37.760983003532566",
    "lon": "-122.43511034949147"
  },
  {
    "camera_id": "17",
    "location": "Townsend and Third St",
    "lat": "37.779030822193945",
    "lon": "-122.3927249159742",
    "iframeUrl": "https://g1.ipcamlive.com/player/player.php?alias=68408c288eb1f",
    "iframeWidth": 800,
    "iframeHeight": 600
  },
  {
    "camera_id": "50",
    "location": "Market and Castro",
    "lat": "37.76181515663832",
    "lon": "-122.43518056075168",
    "iframeUrl": "https://g1.ipcamlive.com/player/player.php?alias=example_alias",
    "iframeWidth": 800,
    "iframeHeight": 600
  }


]; 